import { render, staticRenderFns } from "./CatalogItems.vue?vue&type=template&id=0aee9664"
import script from "./CatalogItems.vue?vue&type=script&lang=js"
export * from "./CatalogItems.vue?vue&type=script&lang=js"
import style0 from "./CatalogItems.vue?vue&type=style&index=0&id=0aee9664&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports